export default __webpack_public_path__ + "2bde72db11e17f42d63ed749ae4b9db7.png";